import EmptyState from "../../../components/empty-state";
import Loading from "../../../components/loading";
import Pager from "../../../components/pager";
import RuleDisplay from "../../../components/rule-display";
import { RulesState } from "../hooks/use-rules";

type RulesListProps = {
  state: RulesState;
};

const RulesList = (props: RulesListProps) => {
  const rulesState: RulesState = props.state;

  return (
    <div className="flex-grow flex flex-col">
      <div className="flex-grow flex flex-col">
        {rulesState.loading && <Loading></Loading>}
        {!rulesState.loading && (
          <div className="grid grid-cols-1  md:grid-cols-3 p-12">
            {!rulesState.loading &&
              rulesState.rules &&
              rulesState.rules.length > 0 &&
              rulesState.rules.map((rule) => {
                return (
                  <div key={`rule-${rule.id}`} className="p-4">
                    <RuleDisplay rule={rule} />
                  </div>
                );
              })}
            {!rulesState.loading &&
              (!rulesState.rules || rulesState.rules.length <= 0) &&
              !rulesState.debouncedQuery && (
                <div className="col-span-3 w-full">
                  <EmptyState>No Rules Available.</EmptyState>
                </div>
              )}
            {!rulesState.loading &&
              (!rulesState.rules || rulesState.rules.length <= 0) &&
              rulesState.debouncedQuery && (
                <div className="col-span-3 w-full">
                  <EmptyState>
                    No Rules found for
                    <span className="font-semibold ml-1">
                      {rulesState.debouncedQuery}
                    </span>
                  </EmptyState>
                </div>
              )}
          </div>
        )}
      </div>
      {!rulesState.loading && (
        <Pager
          page={rulesState.page}
          pageSize={rulesState.pageSize}
          pageOptions={[5, 15, 25, 40]}
          total={rulesState.total}
          showArrows
          onChange={(page, pageSize) => {
            rulesState.updatePaging(page, pageSize);
          }}
        />
      )}
    </div>
  );
};

export default RulesList;
